import { Button } from "@/ui/button";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";

interface PastConversationsButtonProps {
  user: { id: string; email?: string } | null;
  subscribed: boolean;
  onClick: () => void;
  brandVariant?: "default" | "ecole" | "liceo";
}

export function PastConversationsButton({
  user,
  subscribed,
  onClick,
  brandVariant = "default",
}: PastConversationsButtonProps) {
  // Only show for signed-in users
  if (!user) {
    return null;
  }

  return (
    <motion.div whileHover={{ scale: 1.05, y: -2 }} whileTap={{ scale: 0.98 }}>
      <Button
        onClick={onClick}
        variant="ghost"
        className={`hidden sm:inline-flex items-center gap-2 rounded-full border-2 px-4 py-2 text-sm font-bold shadow-lg backdrop-blur-sm transition-all duration-300 ${
          brandVariant !== "default"
            ? "bg-gradient-to-br from-slate-800/90 via-school-blue/10 to-slate-800/90 hover:bg-gradient-to-br hover:from-slate-700/90 hover:via-school-blue/20 hover:to-slate-700/90 border-school-blue/35 hover:border-school-accent/50 text-school-soft hover:text-white hover:shadow-school-blue/20"
            : "bg-gradient-to-br from-slate-800/90 via-orange-900/10 to-slate-800/90 hover:bg-gradient-to-br hover:from-slate-700/90 hover:via-orange-800/15 hover:to-slate-700/90 border-orange-500/30 hover:border-orange-400/50 text-orange-200 hover:text-orange-100 hover:shadow-orange-500/20"
        }`}
        title={subscribed ? "View past conversations" : "Upgrade to access past conversations"}
      >
        {!subscribed && (
          <Lock
            size={16}
            className={brandVariant !== "default" ? "text-school-accent" : "text-orange-400"}
          />
        )}
        Past Conversations
      </Button>
    </motion.div>
  );
}
